module.exports = __webpack_public_path__ + "static/novy-plugin-neon-nette-support-a6fa93f1c855c2992c4dd7866e31e08b.jpg";